export const getAvailableYears = (data, dateField) => {
  const years = new Set();
  data.forEach(item => {
    const date = new Date(item[dateField]);
    if (!isNaN(date)) years.add(date.getFullYear());
  });
  return Array.from(years).sort((a, b) => b - a);
};

export const filterByDateRange = (data, dateField, filter) => {
  const now = new Date();
  
  switch (filter.type) {
    case 'lastYear':
      const oneYearAgo = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate());
      return data.filter(item => new Date(item[dateField]) >= oneYearAgo);
    
    case 'lastMonth':
      const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
      return data.filter(item => new Date(item[dateField]) >= lastMonth);
    
    case 'byYear':
      return data.filter(item => {
        const date = new Date(item[dateField]);
        return !isNaN(date) && date.getFullYear() === filter.year;
      });
    
    default:
      return data;
  }
};
